import React, { useState, useEffect } from "react";
import { useCities, useNearestCity } from "hooks/city";
import Form from "./Form";

const FindBranchForm = ({ className }) => {
  const [searchedCity, setSearchedCity] = useState({
    name: "",
    id: "",
    latitude: 0,
    longitude: 0,
  });

  const [
    fetchCities,
    { data: citiesData, loading, error: citiesError },
  ] = useCities();
  const { nearestCity } = useNearestCity();

  useEffect(() => {
    if (nearestCity) {
      setSearchedCity(nearestCity);
    }
  }, [nearestCity]);

  useEffect(() => {
    fetchCities({ query: "pageSize=1000" });
  }, []);

  return (
    <Form
      className={className}
      searchedCity={searchedCity}
      citiesData={citiesData}
      citiesLoadingError={citiesError}
      citiesLoading={loading}
      onChange={value => {
        setSearchedCity({ ...value });
      }}
    />
  );
};

export default FindBranchForm;
